import { getAccountService } from '../../services/angular-bridge';

export function useCurrentUserEmail(): string {
  try {
    return getAccountService().GetEmail?.() ?? '';
  } catch (_) {
    return '';
  }
}
